export function getCategoriesQuery() {
  return gql`
query getCategories {
  categories(where: {hideEmpty: true}) {
      nodes {
        categoryId
        slug
        name
        description
        categoryMeta {
          featuredIllustration {
            altText
            sourceUrl
          }
        }
      }
    }
}
`
}
